export enum CreateSkipTraceOrderStep {
  SelectSites,
  Summary,
  OrderPlaced,
  OrderConfirmed,
  OrderError,
}
